/** README-criar-agente-no-item.md §3 — the opening conversation, the 3 steps
 *  hosted in the widened assistant panel, plus the post-activation Done
 *  screen. CONVERSATION precedes STEP_1: the user describes the job there and
 *  the server builds the draft Step 1 starts from. */
export enum AgentSetupPanelPhase {
  CONVERSATION = 'CONVERSATION',
  STEP_1 = 'STEP_1',
  STEP_2 = 'STEP_2',
  STEP_3 = 'STEP_3',
  DONE = 'DONE',
}
